"use client";

import { useAuth } from "@/contexts/auth-context";
import { ToastBanner } from "@/components/ui/atoms/toast-banner";

/**
 * « Compte créé. 3 morceaux ajoutés à ta liste. »
 *
 * C'est le seul moment où la promesse du compte devient visible. Sans ce
 * retour, quelqu'un qui vient de s'inscrire n'a aucun signe que ses imports ont
 * suivi, et « Mes morceaux » reste un onglet que personne n'ouvre.
 *
 * Il arrive *après* la fermeture de la modale, parce que la revendication n'est
 * volontairement pas bloquante : on rend la main tout de suite, la confirmation
 * suit quand elle est vraie.
 */
export function ClaimToast() {
  const { claimedEntries, acknowledgeClaim } = useAuth();

  // Volontairement muet sur la creation : la revendication se declenche
  // aussi bien a l inscription qu a la connexion, et annoncer « Compte cree »
  // a quelqu un qui vient de se connecter est faux.
  const message =
    claimedEntries === 1
      ? "1 morceau ajouté à ta liste."
      : `${claimedEntries} morceaux ajoutés à ta liste.`;

  return (
    <ToastBanner
      message={message}
      open={claimedEntries !== null}
      onClose={acknowledgeClaim}
      autoHideMs={6000}
    />
  );
}
